module.exports = __webpack_public_path__ + "static/avanti-logo-f24a8cc4dd109558797e9871fcbe9083.png";